var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A wrapper element for action icons to create an accessible width and height for tapping
 * It will trigger `onClick` for `spacebar` and `enter` keys as well
 * Usage: `<TopbarContent.HamburgerMenu />`
 */
export default function IconActionWrapper(_a) {
    var { children, className = "", onClick } = _a, props = __rest(_a, ["children", "className", "onClick"]);
    return (_jsx("div", Object.assign({ onClick: onClick, onKeyUp: onClick
            ? (event) => {
                const { key } = event;
                if (key === "Enter" || key === " ") {
                    onClick();
                }
            }
            : undefined, tabIndex: 0, className: `
        te-min-w-[48px] te-min-h-[48px] te-flex te-justify-center te-items-center te-cursor-pointer
        ${className}
      ` }, props, { children: children })));
}
